import { ChangeDetectionStrategy, Component, computed, input, model,} from '@angular/core';
import { AbstractComponent, FieldWrapperComponent } from '@spike/scaffolds';
import { FormsModule } from '@angular/forms';
import { Button } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { InputText } from 'primeng/inputtext';
import { OrdineWorkflow } from 'src/app/features/workflow/models/workflow-status.enum';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-orders-filters-form',
  providers: [],
  imports: [CommonModule, Button, FormsModule, FieldWrapperComponent, InputText ],
  templateUrl: './orders-filters-form.html',
})
export class OrdersFiltersFormComponent extends AbstractComponent {
  // Inputs
  readonly workflowState = OrdineWorkflow;
  readonly searchFilter = model.required<any>();

  // Static
  private debounceTimeout?: any;
  // State

  public searchByState(stateId?: number) {
    this.searchFilter.update(f => ({ ...f, stateId: stateId }));
  }


  updateFilter(key: string, value: any) {
    // 1. Puliamo il timeout precedente
    if (this.debounceTimeout) clearTimeout(this.debounceTimeout);

    // 2. Impostiamo un nuovo timeout
    this.debounceTimeout = setTimeout(() => {
      this.searchFilter.update(f => ({ ...f, [key]: value ? value : undefined }));
    }, 500); // 400ms di debounce

  }
}
